import { render, staticRenderFns } from "./PackageOption.vue?vue&type=template&id=72b19842&"
import script from "./PackageOption.vue?vue&type=script&lang=js&"
export * from "./PackageOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports